import React, { Component } from 'react';
import { Flex, Text, Link } from 'core/components';
import Markdown from 'app/components/markdown/Markdown';
import ToolResultCard from '../components/ToolResultCard';

class WebSearchToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { raw_result = {} } = tool;
    const { query, answer, results = [], response_time } = raw_result;

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-web-search"
        title={tool.title || 'Web Search Tool Result'}
        minHeight={isInlineMode ? 400 : 600}
        maxHeight={isInlineMode ? 500 : undefined}
        isInlineMode={isInlineMode}
        overflow="auto"
      >
        <Flex flexDirection="column" px={2}>
          <Text fontWeight="bold" mb={1}>
            {query}
          </Text>
          <Text mb={1}>{answer}</Text>
          {results && results.length > 0 && (
            <>
              <Text fontWeight="bold" mb={1}>
                Sources
              </Text>
              <Flex flexDirection="column" gap={2}>
                {results.map((item) => (
                  <Flex key={item.url} flexDirection="column">
                    <Link to={item.url} blank>
                      {item.title}
                    </Link>
                    {item.published_date && (
                      <Text muted small>
                        Published: {item.published_date}
                      </Text>
                    )}
                    <Markdown>{item.content}</Markdown>
                    {typeof item.score === 'number' && <Text muted>Relevance: {(item.score * 100).toFixed(1)}%</Text>}
                  </Flex>
                ))}
              </Flex>
            </>
          )}
          <Text mt={3} fontSize={0} color="muted">
            Response time: {response_time}s
          </Text>
        </Flex>
      </ToolResultCard>
    );
  }
}

export default WebSearchToolResult;
